import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { MainPageWrapper, ContentCenteredBox } from '@appearance/styled'
import MainButtons from '@components/MainButtons'
import { useUser } from '@state/uses/users'
import { getAppConfig, setAppConfig } from '@state/actions/app'
import { useAppConfig } from '@state/uses/app'

const termsOfUseHeadline = '\n' + 'אז איך זה עובד?'
const welcomeFirstHeadline = 'ארגון המדריכים והיוצרים לריקודי עם'
const welcomeSecondHeadline =
    'ברוכים הבאים למערכת רישום הריקודים של ארגון המדריכים והיוצרים!'
const explanationsHeadline = '\n' + 'יש 3 שלבים לריקוד'

export default () => {
    const dispatch = useDispatch()
    const tmpAppConfig = useAppConfig()
    const history = useHistory()
    const user = useUser()

    const [appConfig, setAppConfig] = useState(tmpAppConfig)
    useEffect(() => {
        if (!tmpAppConfig) {
            dispatch(getAppConfig(setAppConfig))
        } else {
        }
    }, [tmpAppConfig])

    const goToLogin = () => {
        history.push('/login')
    }

    const goToSignup = () => {
        history.push('/signup')
    }

    const mainButtons = [
        {
            label: 'עדיין לא רשומים לאתר?',
            span: 'הירשמו פה',
            onClick: goToSignup,
            bgColor: '#192F3A',
            icon: '',
        },
        {
            label: 'כניסה למערכת',
            span: 'למשתמשים רשומים',
            onClick: goToLogin,
            bgColor: 'rgb(83,71,103)',
            icon: '',
        },
    ]
    const terms_of_use = appConfig?.terms_of_use
    const explanations = appConfig?.explanations
    const welcome = appConfig?.welcome
    const reciepientsList = appConfig?.contact_us_list

    return (
        <Wrapper>
            <ContentCenteredBox>
                {!user && <MainButtons btnsArr={mainButtons}></MainButtons>}
                <Title>{welcomeFirstHeadline}</Title>
                <SubTitle>{welcomeSecondHeadline}</SubTitle>
                <ul>
                    {welcome?.split('\n').map((line) => (
                        <ol>{line}</ol>
                    ))}
                </ul>
                <ui>
                    <ol> </ol>
                    <SubTitle>{termsOfUseHeadline}</SubTitle>
                    <ol> </ol>
                </ui>
                <ul>
                    {terms_of_use?.split('\n').map((line) => (
                        <ol>{line}</ol>
                    ))}
                </ul>
                <ui>
                    <ol> </ol>
                    <SubTitle>{explanationsHeadline}</SubTitle>
                    <ol> </ol>
                </ui>
                <ul>
                    {explanations?.split('\n').map((line) => (
                        <ol>{line}</ol>
                    ))}
                </ul>
                <a href={'mailto:' + reciepientsList}>צור קשר</a>
            </ContentCenteredBox>
        </Wrapper>
    )
}

const Wrapper = styled(MainPageWrapper)`
    padding-bottom: 40px;
`

const Title = styled.h2`
    font-size: 32px;
    margin: 20px 0px;
    text-align: center;
`
const SubTitle = styled.h4`
    font-size: 20px;
    margin-bottom: 8px;
    margin-top: 12px;
`

const Text = styled.p`
    margin-bottom: 20px;
`
const TextTitle = styled.h5`
    font-size: 20px;
    margin-vertical: 8px;
`

{
    /* <Text>
                    {terms_of_use}
                     כדי לדעת כמה ריקודים אתה יכול לרשום, עליך להיכנס ל״פרטים
                    אישיים״ ושם מצויין כמה ריקודים אתם רשאים להזמין ולרשום על
                    שמכם. את המדרג קבעו ועדת יוצרים בראשות ויקטור גבאי, במידה
                    ואתם רוצים לערער, עליכם לפנות ליושב ראש ועדת יוצרים והועדה
                    תדון ותחליט בהתאם. 
                </Text> */
}

{
    /* <Text>
 אנו שמחים להצטרפותך למערכת, בה תוכל באופן ישיר לרשום
ריקודים, לראות ולקבל את כל המידע הדרוש לך. כדי להשתמש באתר
זה עליך להיות חבר בארגון המרקידים והכוריאוגרפים לריקודי עם
ולשלם דמי חבר כמרקיד, או יוצר שאינו מרקיד, ליו״ר ועדת הכספים
- רפי כחלון בסך 300 ש״ח. 
{welcome}
</Text> */
}
